(() => {
  if (window.oleaMenuOverviewReady) return;
  window.oleaMenuOverviewReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-olea-menu-search]');
    if (!button) return;
    const header = button.closest('smart-header');
    const input = header?.querySelector('.header-search-desktop input[type="search"]');
    if (!input) return;
    const focusSearch = () => input.focus({ preventScroll: true });
    const menu = button.closest('dialog');
    if (menu?.open && typeof header.closeDialog === 'function') header.closeDialog(menu, { restoreFocus: false, after: focusSearch });
    else focusSearch();
  });
})();
